import React from "react";
import { offerConfig } from "../data/megapack";
import { useCountdown } from "../hooks/useCountdown";
import { E } from "./Emoji";
type CountdownProps = {
  title: string;
  compact?: boolean;
};
const pad = (n: number) => String(n).padStart(2, "0");
export function Countdown({
  title,
  compact = false
}: CountdownProps) {
  const {
    ended,
    days,
    hours,
    minutes,
    seconds
  } = useCountdown(offerConfig.endsAt);
  const groups: [string, string][] = [...(days > 0 ? [[pad(days), "DÍAS"]] as [string, string][] : []), [pad(hours), "HS"], [pad(minutes), "MIN"], [pad(seconds), "SEG"]];
  const digit = compact ? "text-5xl md:text-6xl" : "text-6xl md:text-7xl";
  return <div className="text-center" data-id="element-15" data-mp="3729l143anwhc">
      <h3 className={`font-black uppercase leading-tight text-white ${compact ? "text-xl" : "text-2xl md:text-3xl"}`} data-id="element-16" data-mp="373kt3g3rvqe9">
        <E data-id="element-17" data-mp="10a8ts6o1lvxe">{title}</E>
      </h3>
      {ended ? <p className="mt-5 text-lg font-bold text-red" data-id="element-18" data-mp="15boetyq802fs">La oferta de lanzamiento finalizó.</p> : <div className="mt-5 flex items-start justify-center gap-1 md:gap-2" role="timer" data-id="element-19" data-mp="y0es26zuwm44">
          {groups.map(([v, label], i) => <React.Fragment key={label} data-id="element-20" data-mp="t1tpw211nsd1" data-mpi={i}>
              {i > 0 && <span className={`${digit} font-black leading-none text-red`} data-id="element-21" data-mp="17rhsd6kyox2c">:</span>}
              <div className="flex flex-col items-center" data-id="element-22" data-mp="12s554kq6hnz8">
                <span className={`${digit} font-black leading-none tabular-nums text-red`} data-id="element-23" data-mp="12sokpuscw0a3">{v}</span>
                <span className="mt-2 text-xs font-bold tracking-wider text-white/70" data-id="element-24" data-mp="f2kgpmb99yik">{label}</span>
              </div>
            </React.Fragment>)}
        </div>}
    </div>;
}